import SeminarCancel from "./SeminarCancel";
import DownloadOverlay from "./DownloadOverlay";


/**
 * SeminarDetails
 * Handles all JS stuff for seminar details page
 */
export default class SeminarDetails {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);
        this.googleMapBuilded = false;
        this.historyFilter = null;
        this.plannedFilter = null;
        this.criticalFilter = null;

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        this.initialLoad();

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path) {
                case '#!/0':
                    new DownloadOverlay('[data-tncp-download-overlay]');
                    _this.changeTab();
                    break;
                case '#!/1':
                    _this.changeTab();
                    break;
                case '#!/2':
                    _this.changeTab();
                    break;
            }
        });
    }


    /**
	 * this script is loaded on pageload
	 * to get information like title
     */
    initialLoad() {
    	let vm = this;
        let $dynamicElement = this.$plugin.find('[data-tncp-tabs-content-id="0"] [data-tncp-xhr]');
        window.xhrRequest({
            url: $dynamicElement.data('tncp-xhr')
        }).then((response) => {
            vm.$plugin.find('[data-tncp-seminarDetails-title]').html(response.data.title);
        });
    }

    /**
     * This function is called on tab change by router event
     */
    changeTab() {
        let vm = this;

        vm.loadData();
    }

    /**
	 *
     * @param routeId
     */
    loadData(routeId = '') {
        let vm = this;
        if (routeId === '') {
            routeId = window.tncpRouter.getRoute();
        }
        let $dynamicElements = this.$plugin.find('[data-tncp-tabs-content-id="' + routeId + '"] [data-tncp-xhr]');

        _.forEach($dynamicElements, (element, index) => {
            const xhrPath = $(element).data('tncp-xhr');
            vm.request = window.xhrRequest({
                url: xhrPath
            }).then((response) => {

                $(element).html(response.data.content);
                vm.reinitJsCode();

            }).then(function () {
                var ElementQueries = require('css-element-queries/src/ElementQueries');
                ElementQueries.listen();
                ElementQueries.init();

                //Initialize SeminarCancel only once
                if(index == 0) {
                    // SeminarDetails is used on the detail page for the facilities
                    new SeminarCancel('[data-tncp-plugin="SeminarCancel"]');
                }
            });
        });
    }


    // libraries to reinitialize
    reinitJsCode() {
        jsGallery();
    }

}